// Mock data for St. Croix Appraisals

export const mockEmailSubmissions = [];

export const mockContactSubmissions = [];

export const servicesData = [
  {
    id: 1,
    title: "Single Family Home Appraisals",
    slug: "single-family",
    description: "Comprehensive appraisals for single-family residential properties",
    icon: "Home",
    details: {
      overview: "Our single-family home appraisal services provide accurate, reliable valuations for residential properties. We conduct thorough inspections and analysis to deliver reports that meet all lending and legal requirements.",
      includes: [
        "Comprehensive property inspection",
        "Market analysis and comparable sales research",
        "Detailed interior and exterior assessment",
        "USPAP compliant reporting",
        "Photos and property sketches",
        "Timely delivery within 48-72 hours"
      ],
      ideal: "Perfect for home purchases, refinancing, estate planning, divorce settlements, and tax appeals."
    }
  },
  {
    id: 2,
    title: "Condominium Appraisals",
    slug: "condominium",
    description: "Specialized valuations for condominium units and properties",
    icon: "Building2",
    details: {
      overview: "Condominium appraisals require specialized knowledge of HOA regulations, shared amenities, and complex ownership structures. Our expertise ensures accurate valuations that account for all unique factors.",
      includes: [
        "Unit-specific inspection and analysis",
        "HOA documentation review",
        "Amenity and common area assessment",
        "Comparable unit analysis",
        "Building condition evaluation",
        "FHA/VA compliance when needed"
      ],
      ideal: "Essential for condo purchases, refinancing, litigation support, and portfolio evaluation."
    }
  },
  {
    id: 3,
    title: "Townhome & Land Appraisals",
    slug: "townhome-land",
    description: "Expert appraisals for townhomes and vacant land parcels",
    icon: "MapPin",
    details: {
      overview: "Whether you need a townhome valuation or vacant land assessment, we provide detailed appraisals that consider all relevant factors including zoning, development potential, and market conditions.",
      includes: [
        "Property boundary verification",
        "Zoning and land use analysis",
        "Highest and best use evaluation",
        "Environmental considerations",
        "Access and utility assessment",
        "Market and neighborhood analysis"
      ],
      ideal: "Ideal for land development, townhome transactions, estate planning, and investment analysis."
    }
  }
];

export const aboutData = {
  headline: "Trusted Appraisal Expertise in the Twin Cities & Wisconsin",
  intro: "With over 15 years of experience in residential property appraisal, St. Croix Appraisals delivers accurate, timely, and professional valuation services you can trust.",
  credentials: [
    "State Certified Residential Appraiser",
    "Member, Appraisal Institute",
    "USPAP Certified",
    "FHA/VA Approved Appraiser"
  ],
  experience: "Having completed over 5,000 appraisals throughout the Twin Cities metro area and Wisconsin, we bring unmatched local market knowledge and expertise to every assignment. Our commitment to accuracy, integrity, and timely service has made us the preferred choice for homeowners, real estate professionals, and lending institutions.",
  mission: "To provide objective, well-supported property valuations that serve the needs of our clients while maintaining the highest standards of professional ethics and competence."
};

export const linksData = [
  {
    category: "Professional Organizations",
    links: [
      { name: "Appraisal Institute", url: "https://www.appraisalinstitute.org" },
      { name: "National Association of Realtors", url: "https://www.nar.realtor" }
    ]
  },
  {
    category: "Resources",
    links: [
      { name: "USPAP Guidelines", url: "#" },
      { name: "Local Market Reports", url: "#" },
      { name: "Appraisal FAQs", url: "#" }
    ]
  }
];

export const contactInfo = {
  email: "tomsuttle@comcast.net",
  phone: "(651) 429-4686",
  address: "Mahtomedi, MN",
  hours: "Monday - Friday: 9:00 AM - 5:00 PM"
};

// Mock functions
export const submitEmail = (email) => {
  mockEmailSubmissions.push({
    email,
    timestamp: new Date().toISOString()
  });
  console.log('Email submitted to mock storage:', email);
  return Promise.resolve({ success: true });
};

export const submitContact = (formData) => {
  mockContactSubmissions.push({
    ...formData,
    timestamp: new Date().toISOString()
  });
  console.log('Contact form submitted to mock storage:', formData);
  return Promise.resolve({ success: true });
};